import React, { FC } from 'react';

import { ChildrenProps } from '../../../../../utils';

import './IdentificationBlockGroup.scss';

interface Props extends ChildrenProps {}

const IdentificationBlockGroup: FC<Props> = ({ children }) => {
  return <div className="identification-block-group">{children}</div>;
};

export default IdentificationBlockGroup;
